export const FinDocDocTypeObj = {
  noBounceCert: "無退票證明",
  tax401Cert: "401營業稅申報書納稅證明",
  financialReport: "財報",
  taxReport: "稅報",
  companyRegForm: "公司登記表",
  otherFinDoc: "其他文件（僅財務相關報表或文件）",
};

export const FinDocCompanyObj = {
  WIA: "WiAdvance 緯謙科技",
  WIT: "Wintelligent 緯銘",
};

export const FinDocDocTypeOptions = Object.entries(FinDocDocTypeObj).map(([value, label]) => ({
  label,
  value,
}));

export const FinDocCompanyOptions = Object.entries(FinDocCompanyObj).map(([value, label]) => ({
  label,
  value,
}));
